import React, { FC, lazy, Suspense } from "react";
import { Provider } from "react-redux";
import store from "../../redux/store";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { PanelLoader } from "../loader";
import Routes from "../../routes/routes";
import { usePanel } from "@hooks/loadingHooks";
import { Chart as ChartJS, registerables } from 'chart.js';
import { Toaster } from 'react-hot-toast';

// Lazy load metrics components
const YandexMetrika = lazy(() => import("@components/metrics/yandexMetrika"));
const MailRuCounter = lazy(() => import("@components/metrics/mailRuCounter"));

ChartJS.register(...registerables);
library.add(fas);

const App: React.FC = () => {
    return (
        <Provider store={store}>
            <PanelLoader>
                <Routes />
            </PanelLoader>
            <Metrics />
            <Toaster
                position="top-right"
                reverseOrder={false}
                gutter={8}
                toastOptions={{
                    duration: 4000,

                }}
            />
        </Provider>
    );
};

const Metrics: FC = () => {
    const { ymId, mailRuCounterId } = usePanel();

    return (
        <Suspense fallback={null}>
            {Boolean(ymId) && <YandexMetrika id={ymId!}/>}
            {Boolean(mailRuCounterId) && <MailRuCounter id={mailRuCounterId!}/>}
        </Suspense>
    )
}

export default App;